import { Link } from "react-router-dom";
import { assets } from "@/lib/assets";
import "@/components/landing/PricingShowcase.css";

export const PricingShowcase = () => (
  <section id="pricing" className="pricing-image-section" data-testid="landing-pricing-section">
    <h2 className="sr-only" data-testid="pricing-heading">Professional SEO tools for $19 per month</h2>
    <img src={assets.landingPricing} width={1672} height={941} loading="lazy" decoding="async" alt="seorank.doctor pricing illustration: professional SEO tools for $19 per month, including AI-powered analysis, keyword tracking, backlink monitoring, and live visitor data." data-testid="pricing-showcase-image"/>
    <Link to="/app" className="pricing-image-cta" aria-label="Get started with a 7-day free trial, then $19 per month" data-testid="pricing-start-button"><span className="sr-only">Get Started for $19/month</span></Link>
  </section>
);